// @flow
import * as React from 'react';
import { intlShape } from 'react-intl';
import { withRouter, Link } from 'react-router-dom';
import { Pill, pillSizes, pillColours } from 'moods-react/Pill';
import { envUrl } from '../../services/environment/EnvironmentService';
import { TabNavigation } from '../../../components/TabNavigation/TabNavigation';
import { SelectDropdown } from '../../../components/SelectDropdown';

import './NavBar.scss';

export type TooltipType = {
  header: string,
  text: string,
};

type Option = {
  value: string,
  label: string,
};

type NavItem = Option & {
  badgeValue?: number,
  tooltip?: TooltipType,
};

type Props = {
  items: Array<NavItem>,
  activeRoute: string,
  page: string,
  message: Object,
  history: Object,
  isScrollable: boolean,
};

function buildTabLabel(tab) {
  const navBarItemBadge = tab.badgeValue ? (
    <Pill className="u-marginLeft-xxs" size={pillSizes.SMALL} colour={pillColours.BLUEBERGINE}>
      {tab.badgeValue}
    </Pill>
  ) : null;

  return (
    <div className="nav-bar__label">
      {tab.label}
      {navBarItemBadge}
    </div>
  );
}

const NavBar = ({ items, activeRoute, page, message, history }: Props) => {
  const singleItem = items.length === 1;
  const tabs = items.map((navBarItem) => {
    return {
      ...navBarItem,
      selected: navBarItem.value === activeRoute,
      delegateProps: { to: navBarItem.value },
      label: buildTabLabel(navBarItem),
    };
  });

  const dropdownItems = (
    <SelectDropdown
      values={items.map((item) => [item.value, item.label])}
      defaultValue={activeRoute}
      onChange={(value) => history.push(envUrl(`/${page}/${value}`))}
    />
  );

  return (
    <div className={`nav-bar ${singleItem ? '' : 'nav-bar--responsive'}`}>
      {/* Desktop */}
      <nav className={`nav-bar__menu ${singleItem ? '' : 'nav-bar__menu--hidden-until-medium'}`}>
        <TabNavigation tabs={tabs} delegate={Link} />
      </nav>

      {/* Mobile & Tablet */}
      <div className={`nav-bar__dropdown ${singleItem ? 'u-display-none' : ''}`}>
        <div className="nav-bar__title">{message}</div>
        {dropdownItems}
      </div>
    </div>
  );
};

NavBar.contextTypes = {
  intl: intlShape.isRequired,
};

export default withRouter(NavBar);
